import { Business } from 'model';
import isEmail from 'validator/lib/isEmail';
import isURL from 'validator/lib/isURL';
import { FormValidationRules } from '../hooks/useFormValues';

export type BusinessWithSimpleItems = Business & { itemString: string };
export const BusinessEditRules: FormValidationRules<BusinessWithSimpleItems> = {
	name: {
		rules: {
			maxLength: {
				value: 50,
				message: 'Must be less than 50 characters'
			},
			required: {
				value: true,
				message: 'Name is required'
			}
		}
	},
	description: {
		rules: {
			required: {
				value: true,
				message: 'Content is required'
			},
			maxLength: {
				value: 1000,
				message: 'Must be less than 1000 characters'
			}
		}
	},
	businessType: {
		rules: {
			required: {
				value: true,
				message: 'Business Type is required'
			}
		}
	},
	logoURL: {
		rules: {
			func: {
				value: value => value === '' || isURL(value),
				message: 'Image must be a valid URL'
			}
		}
	},

	bannerURL: {
		rules: {
			func: {
				value: value => value === '' || isURL(value),
				message: 'Image must be a valid URL'
			}
		}
	},

	address: {
		rules: {
			required: {
				value: true,
				message: 'Address is required'
			}
		}
	},
	city: {
		rules: {
			required: {
				value: true,
				message: 'City is required'
			}
		}
	},
	website: {
		rules: {
			func: {
				value: value => value === '' || isURL(value),
				message: 'Website must be a valid URL'
			}
		}
	},
	phone: {},
	email: {
		rules: {
			func: {
				value: (value: string) => value === '' || isEmail(value),
				message: 'Incorrectly formatted email'
			}
		}
	},
	itemString: {
		rules: {
			func: {
				value: (value: string) => {
					const items = value.split(',').map(item => item.trim());
					return items.every(item => item.length < 50);
				},
				message: 'Must be a comma separated list, each under 50 characters'
			},
			maxLength: {
				value: 1000,
				message: 'Item must be less than 1000 characters total'
			}
		}
	},
	hours: {},
	district: {},
	status: {},
	patio: {},
	services: {},
	delivery: {},
	otherDelivery: {}
};

export const SubmitBusinessEditRules: FormValidationRules<BusinessWithSimpleItems> = {
	name: {
		rules: {
			maxLength: {
				value: 50,
				message: 'Must be less than 50 characters'
			},
			minLength: {
				value: 4,
				message: 'Must be greater than 3 characters'
			},
			required: {
				value: true,
				message: 'Name is required'
			}
		}
	},
	description: {},
	businessType: {
		rules: {
			required: {
				value: true,
				message: 'Business Type is required'
			}
		}
	},
	logoURL: {
		rules: {
			func: {
				value: value => value === '' || isURL(value),
				message: 'Image must be a valid URL'
			}
		}
	},

	bannerURL: {
		rules: {
			func: {
				value: value => value === '' || isURL(value),
				message: 'Image must be a valid URL'
			}
		}
	},

	address: {},
	city: {},
	website: {
		rules: {
			func: {
				value: value => value === '' || isURL(value),
				message: 'Website must be a valid URL'
			}
		}
	},
	phone: {},
	email: {
		rules: {
			func: {
				value: (value: string) => value === '' || isEmail(value),
				message: 'Incorrectly formatted email'
			}
		}
	},
	itemString: {
		rules: {
			func: {
				value: (value: string) => {
					const items = value.split(',').map(item => item.trim());
					return items.every(item => item.length < 50);
				},
				message: 'Must be a comma separated list, each under 50 characters'
			},
			maxLength: {
				value: 1000,
				message: 'Item must be less than 1000 characters total'
			}
		}
	},
	hours: {},
	district: {},
	status: {},
	patio: {},
	services: {},
	delivery: {},
	otherDelivery: {}
};
